// Layouts
import PageLayer from "@/Layouts/views/PageLayer";

// Model
import PayPlanAssignment from "@PayPlans/models/Assignments/Current";

// MUI
import { Stack, SvgIcon } from "@mui/material";

// Icons
import { ReactComponent as Icon } from "@/assets/icons/header/payplans/Current.svg";

export default function Individual() {
	return (
		<PageLayer
			title="Current Pay Plan Assignments"
			icon={
				<Stack width={1} direction={"row"} justifyContent={"center"} alignItems={"center"}>
					<SvgIcon
						viewBox="-2 -2 24 24"
						className="text-[var(--strong-purple-color)] [&>path]:!fill-[var(--strong-purple-color)] !text-[27px]"
						component={Icon}
					/>
				</Stack>
			}
		>
			<PayPlanAssignment />
		</PageLayer>
	);
}
